import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  }
}));

export default function SaasClientsUpdate({ match, history }) {

  const rota = 'saas-client';
  const roleName = 'Clientes Saas';

  const [redirect, setRedirect] = React.useState(false);
  const [id, setId] = React.useState('');
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [siteWp, setSiteWp] = React.useState('');
  const [master, setMaster] = React.useState(false);
  const [token, setToken] = React.useState('');


  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [previewImage, setPreviewImage] = React.useState('');
  const [thumbnail, setThumbnail] = React.useState(null);  
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  const preview = useMemo(() => {
    return thumbnail ? URL.createObjectURL(thumbnail) : null
  }, [thumbnail])


  const loadData = async () => {
    setId(match.params.id)
    const data = await api.get('/v1/saas/' + match.params.id)
    setName(data.data.name)
    setEmail(data.data.email)
    setSiteWp(data.data.siteWp)
    setMaster(data.data.master)
    setToken(data.data.token)
    if( data.data &&  data.data.photo ){
      const photoUrl = `${data.data.baseUrl+data.data.photo}`
      setPreviewImage(photoUrl)
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  const save = async () => {

    const data = new FormData();
    data.append('photo', thumbnail)
    data.append('name', name)
    data.append('email', email)
    data.append('siteWp', siteWp)
    data.append('master', master ? 1 : 0)
    data.append('token', token)
    data.append('previewImage', preview)
    data.append('crop', JSON.stringify(croppedAreaPixels))
    data.append('_method', 'PUT')
    try {      
      const res = await api.post('/v1/saas/' + id, data, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
      setAlertTitle('')
      history.push('/' + rota)
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${rota}`} >
                  {roleName}
                </Link>
                <Typography color="textPrimary">Cadastro</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} >
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="token"
                        label="Token"
                        type="text"
                        id="token"
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="siteWp"
                        label="Site WordPress"
                        type="text"
                        id="siteWp"
                        value={siteWp}
                        onChange={(e) => setSiteWp(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={<Checkbox value={!!master} color="primary" 
                        checked={!!master}
                        onChange={(e) => setMaster(!master)} />}
                        label="Pode criar outros Clientes SaaS"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid item xs={6}>
                        <ImageUpload 
                          onCropComplete={(croppedArea, croppedAreaPixels)=>{
                            setCroppedAreaPixels(croppedAreaPixels)
                          }}
                          onChange={event => setThumbnail(event.target.files[0])}
                          previewChange={preview}  
                          previewImage={previewImage}
                          remove={(flag)=> {
                            if(flag){
                              setPreviewImage('');
                            }
                            setThumbnail(null);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          setRedirect(`/${rota}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}